import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { ExdInfoTip } from "./ExdControls";
import { EXD, ExdCrumb, ExdWidgetSkeleton, widgetSx } from "./exdMui";

const WidgetShell = ({
  title,
  subtitle,
  infoTitle,
  loading = false,
  controls,
  children,
  variant = "default",
  summary,
  sx = {},
}) => {
  if (loading) return <ExdWidgetSkeleton />;

  return (
    <Paper elevation={0} component="section" sx={{ ...widgetSx(variant), ...sx }}>
      {(title || controls || infoTitle) && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          flexWrap="nowrap"
          sx={{ minHeight: 28, width: "100%" }}
        >
          {title ? (
            <Typography
              component="h3"
              title={typeof title === "string" ? title : undefined}
              noWrap
              sx={{
                color: EXD.text,
                flex: "1 1 auto",
                fontSize: 13.5,
                fontWeight: 700,
                letterSpacing: 0,
                lineHeight: 1.25,
                m: 0,
                minWidth: 0,
              }}
            >
              {title}
              {subtitle ? (
                <>
                  {" "}
                  <ExdCrumb>{subtitle}</ExdCrumb>
                </>
              ) : null}
            </Typography>
          ) : (
            <Box sx={{ flex: 1 }} />
          )}
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.75}
            sx={{ flex: "0 0 auto", ml: "auto" }}
          >
            {controls}
            <ExdInfoTip title={infoTitle} />
          </Stack>
        </Stack>
      )}
      {summary}
      <Box
        sx={{
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          minHeight: 0,
          overflow: "visible",
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Paper>
  );
};

export default WidgetShell;
